function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["__scopeCollapsible", "open", "defaultOpen", "disabled", "onOpenChange"],
  _excluded2 = ["__scopeCollapsible"],
  _excluded3 = ["forceMount"],
  _excluded4 = ["__scopeCollapsible", "present", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var $f0mF1$babelruntimehelpersextends = require("@babel/runtime/helpers/extends");
var $f0mF1$react = require("react");
var $f0mF1$radixuiprimitive = require("@radix-ui/primitive");
var $f0mF1$radixuireactcontext = require("@radix-ui/react-context");
var $f0mF1$radixuireactusecontrollablestate = require("@radix-ui/react-use-controllable-state");
var $f0mF1$radixuireactuselayouteffect = require("@radix-ui/react-use-layout-effect");
var $f0mF1$radixuireactcomposerefs = require("@radix-ui/react-compose-refs");
var $f0mF1$radixuireactprimitive = require("@radix-ui/react-primitive");
var $f0mF1$radixuireactpresence = require("@radix-ui/react-presence");
var $f0mF1$radixuireactid = require("@radix-ui/react-id");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
$parcel$export(module.exports, "createCollapsibleScope", function () {
  return $e729681ae85df948$export$952b32dcbe73087a;
});
$parcel$export(module.exports, "Collapsible", function () {
  return $e729681ae85df948$export$6eb0f7ddcda6131f;
});
$parcel$export(module.exports, "CollapsibleTrigger", function () {
  return $e729681ae85df948$export$c135dce7b15bbbdc;
});
$parcel$export(module.exports, "CollapsibleContent", function () {
  return $e729681ae85df948$export$aadde00976f34151;
});
$parcel$export(module.exports, "Root", function () {
  return $e729681ae85df948$export$be92b6f5f03c0fe9;
});
$parcel$export(module.exports, "Trigger", function () {
  return $e729681ae85df948$export$41fb9f06171c75f4;
});
$parcel$export(module.exports, "Content", function () {
  return $e729681ae85df948$export$7c6e2c02157bb7d2;
});

/* -------------------------------------------------------------------------------------------------
 * Collapsible
 * -----------------------------------------------------------------------------------------------*/
var $e729681ae85df948$var$COLLAPSIBLE_NAME = 'Collapsible';
var _$f0mF1$radixuireactc = $f0mF1$radixuireactcontext.createContextScope($e729681ae85df948$var$COLLAPSIBLE_NAME),
  _$f0mF1$radixuireactc2 = _slicedToArray(_$f0mF1$radixuireactc, 2),
  $e729681ae85df948$var$createCollapsibleContext = _$f0mF1$radixuireactc2[0],
  $e729681ae85df948$export$952b32dcbe73087a = _$f0mF1$radixuireactc2[1];
var _$e729681ae85df948$va = $e729681ae85df948$var$createCollapsibleContext($e729681ae85df948$var$COLLAPSIBLE_NAME),
  _$e729681ae85df948$va2 = _slicedToArray(_$e729681ae85df948$va, 2),
  $e729681ae85df948$var$CollapsibleProvider = _$e729681ae85df948$va2[0],
  $e729681ae85df948$var$useCollapsibleContext = _$e729681ae85df948$va2[1];
var $e729681ae85df948$export$6eb0f7ddcda6131f = /*#__PURE__*/$f0mF1$react.forwardRef(function (props, forwardedRef) {
  var __scopeCollapsible = props.__scopeCollapsible,
    openProp = props.open,
    defaultOpen = props.defaultOpen,
    disabled = props.disabled,
    onOpenChange = props.onOpenChange,
    collapsibleProps = _objectWithoutProperties(props, _excluded);
  var _$f0mF1$radixuireactu = $f0mF1$radixuireactusecontrollablestate.useControllableState({
      prop: openProp,
      defaultProp: defaultOpen,
      onChange: onOpenChange
    }),
    _$f0mF1$radixuireactu2 = _slicedToArray(_$f0mF1$radixuireactu, 2),
    _$f0mF1$radixuireactu3 = _$f0mF1$radixuireactu2[0],
    open = _$f0mF1$radixuireactu3 === void 0 ? false : _$f0mF1$radixuireactu3,
    setOpen = _$f0mF1$radixuireactu2[1];
  return /*#__PURE__*/$f0mF1$react.createElement($e729681ae85df948$var$CollapsibleProvider, {
    scope: __scopeCollapsible,
    disabled: disabled,
    contentId: $f0mF1$radixuireactid.useId(),
    open: open,
    onOpenToggle: $f0mF1$react.useCallback(function () {
      return setOpen(function (prevOpen) {
        return !prevOpen;
      });
    }, [setOpen])
  }, /*#__PURE__*/$f0mF1$react.createElement($f0mF1$radixuireactprimitive.Primitive.div, $parcel$interopDefault($f0mF1$babelruntimehelpersextends)({
    "data-state": $e729681ae85df948$var$getState(open),
    "data-disabled": disabled ? '' : undefined
  }, collapsibleProps, {
    ref: forwardedRef
  })));
});
/*#__PURE__*/
Object.assign($e729681ae85df948$export$6eb0f7ddcda6131f, {
  displayName: $e729681ae85df948$var$COLLAPSIBLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * CollapsibleTrigger
 * -----------------------------------------------------------------------------------------------*/
var $e729681ae85df948$var$TRIGGER_NAME = 'CollapsibleTrigger';
var $e729681ae85df948$export$c135dce7b15bbbdc = /*#__PURE__*/$f0mF1$react.forwardRef(function (props, forwardedRef) {
  var __scopeCollapsible = props.__scopeCollapsible,
    triggerProps = _objectWithoutProperties(props, _excluded2);
  var context = $e729681ae85df948$var$useCollapsibleContext($e729681ae85df948$var$TRIGGER_NAME, __scopeCollapsible);
  return /*#__PURE__*/$f0mF1$react.createElement($f0mF1$radixuireactprimitive.Primitive.button, $parcel$interopDefault($f0mF1$babelruntimehelpersextends)({
    type: "button",
    "aria-controls": context.contentId,
    "aria-expanded": context.open || false,
    "data-state": $e729681ae85df948$var$getState(context.open),
    "data-disabled": context.disabled ? '' : undefined,
    disabled: context.disabled
  }, triggerProps, {
    ref: forwardedRef,
    onClick: $f0mF1$radixuiprimitive.composeEventHandlers(props.onClick, context.onOpenToggle)
  }));
});
/*#__PURE__*/
Object.assign($e729681ae85df948$export$c135dce7b15bbbdc, {
  displayName: $e729681ae85df948$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * CollapsibleContent
 * -----------------------------------------------------------------------------------------------*/
var $e729681ae85df948$var$CONTENT_NAME = 'CollapsibleContent';
var $e729681ae85df948$export$aadde00976f34151 = /*#__PURE__*/$f0mF1$react.forwardRef(function (props, forwardedRef) {
  var forceMount = props.forceMount,
    contentProps = _objectWithoutProperties(props, _excluded3);
  var context = $e729681ae85df948$var$useCollapsibleContext($e729681ae85df948$var$CONTENT_NAME, props.__scopeCollapsible);
  return /*#__PURE__*/$f0mF1$react.createElement($f0mF1$radixuireactpresence.Presence, {
    present: forceMount || context.open
  }, function (_ref) {
    var present = _ref.present;
    return /*#__PURE__*/$f0mF1$react.createElement($e729681ae85df948$var$CollapsibleContentImpl, $parcel$interopDefault($f0mF1$babelruntimehelpersextends)({}, contentProps, {
      ref: forwardedRef,
      present: present
    }));
  });
});
/*#__PURE__*/
Object.assign($e729681ae85df948$export$aadde00976f34151, {
  displayName: $e729681ae85df948$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/
var $e729681ae85df948$var$CollapsibleContentImpl = /*#__PURE__*/$f0mF1$react.forwardRef(function (props, forwardedRef) {
  var __scopeCollapsible = props.__scopeCollapsible,
    present = props.present,
    children = props.children,
    contentProps = _objectWithoutProperties(props, _excluded4);
  var context = $e729681ae85df948$var$useCollapsibleContext($e729681ae85df948$var$CONTENT_NAME, __scopeCollapsible);
  var _$f0mF1$react$useStat = $f0mF1$react.useState(present),
    _$f0mF1$react$useStat2 = _slicedToArray(_$f0mF1$react$useStat, 2),
    isPresent = _$f0mF1$react$useStat2[0],
    setIsPresent = _$f0mF1$react$useStat2[1];
  var ref = $f0mF1$react.useRef(null);
  var composedRefs = $f0mF1$radixuireactcomposerefs.useComposedRefs(forwardedRef, ref);
  var heightRef = $f0mF1$react.useRef(0);
  var height = heightRef.current;
  var widthRef = $f0mF1$react.useRef(0);
  var width = widthRef.current; // when opening we want it to immediately open to retrieve dimensions
  // when closing we delay `present` to retrieve dimensions before closing
  var isOpen = context.open || isPresent;
  var isMountAnimationPreventedRef = $f0mF1$react.useRef(isOpen);
  var originalStylesRef = $f0mF1$react.useRef();
  $f0mF1$react.useEffect(function () {
    var rAF = requestAnimationFrame(function () {
      return isMountAnimationPreventedRef.current = false;
    });
    return function () {
      return cancelAnimationFrame(rAF);
    };
  }, []);
  $f0mF1$radixuireactuselayouteffect.useLayoutEffect(function () {
    var node = ref.current;
    if (node) {
      originalStylesRef.current = originalStylesRef.current || {
        transitionDuration: node.style.transitionDuration,
        animationName: node.style.animationName
      }; // block any animations/transitions so the element renders at its full dimensions
      node.style.transitionDuration = '0s';
      node.style.animationName = 'none'; // get width and height from full dimensions
      var rect = node.getBoundingClientRect();
      heightRef.current = rect.height;
      widthRef.current = rect.width; // kick off any animations/transitions that were originally set up if it isn't the initial mount
      if (!isMountAnimationPreventedRef.current) {
        node.style.transitionDuration = originalStylesRef.current.transitionDuration;
        node.style.animationName = originalStylesRef.current.animationName;
      }
      setIsPresent(present);
    }
    /**
     * depends on `context.open` because it will change to `false`
     * when a close is triggered but `present` will be `false` on
     * animation end (so when close finishes). This allows us to
     * retrieve the dimensions *before* closing.
     */
  }, [context.open, present]);
  return /*#__PURE__*/$f0mF1$react.createElement($f0mF1$radixuireactprimitive.Primitive.div, $parcel$interopDefault($f0mF1$babelruntimehelpersextends)({
    "data-state": $e729681ae85df948$var$getState(context.open),
    "data-disabled": context.disabled ? '' : undefined,
    id: context.contentId,
    hidden: !isOpen
  }, contentProps, {
    ref: composedRefs,
    style: _objectSpread(_defineProperty(_defineProperty({}, "--radix-collapsible-content-height", height ? "".concat(height, "px") : undefined), "--radix-collapsible-content-width", width ? "".concat(width, "px") : undefined), props.style)
  }), isOpen && children);
});
/* -----------------------------------------------------------------------------------------------*/
function $e729681ae85df948$var$getState(open) {
  return open ? 'open' : 'closed';
}
var $e729681ae85df948$export$be92b6f5f03c0fe9 = $e729681ae85df948$export$6eb0f7ddcda6131f;
var $e729681ae85df948$export$41fb9f06171c75f4 = $e729681ae85df948$export$c135dce7b15bbbdc;
var $e729681ae85df948$export$7c6e2c02157bb7d2 = $e729681ae85df948$export$aadde00976f34151;